module.exports = __webpack_public_path__ + "resources/c5ae2733eb0b42e895b9ad7076ad886f.png";